import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { capitalize } from '../../../../../../../util/text';

const propTypes = {
  className: PropTypes.string,
  subscription: PropTypes.shape({
    id: PropTypes.string.isRequired,
    billing_period: PropTypes.string.isRequired,
  }).isRequired,
};

const PhotoManagerSubscriptionTitle = ({ className, subscription }) => {
  const classes = classNames({
    [className]: !!className,
  });

  const isTrial = subscription.trial_days > 0;

  const base = isTrial ? 'Photo Manager - Free Trial' : 'Photo Manager';

  return (
    <p className={classes}>
      {base} ({capitalize(subscription.billing_period)})
    </p>
  );
};

PhotoManagerSubscriptionTitle.propTypes = propTypes;

export default PhotoManagerSubscriptionTitle;
